<nx-dialog [dialogData]="data">
  <form [formGroup]="newDurationForm" class="dialog-content">
    @if (data['showNameInput']) {
      <mat-form-field appearance="outline">
        <input
          matInput
          formControlName="name"
          placeholder="Name"
          autocomplete="off"
          [matAutocomplete]="auto"
          [errorStateMatcher]="immediateMatcher"
          maxlength="100"
          #name
          >
        @if (newDurationForm.controls.name.hasError('required')) {
          <mat-error>
            Name ist benötigt!
          </mat-error>
        }
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setActivityType($event)">
          @for (timer of timerService.filteredTimersForAutocomplete$ | async; track timer) {
            <mat-option [value]="timer.name">
              <span>{{ timer.name }} {{ timer.description }}</span>
            </mat-option>
          }
        </mat-autocomplete>
        <mat-hint align="end">{{ name.value.length }} / 100</mat-hint>
      </mat-form-field>
    }
    @if (!editableDurationsListService.dateFrom) {
      <mat-form-field appearance="outline">
        <input
          matInput
          [matDatepicker]="picker"
          placeholder="Datum auswählen"
          #pickerInput
          (dateChange)="setDateValue($event.value)"
          formControlName="datepicker"
          [errorStateMatcher]="immediateMatcher"
          >
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    }
    Von:
    <mat-form-field appearance="outline" class="durationFrom">
      <input matInput formControlName="durationFrom" autocomplete="off" [errorStateMatcher]="immediateMatcher"
        maxlength="5">
      @if (newDurationForm.controls.durationFrom.hasError('timeFormatError')) {
        <mat-error>Zeitformat: HH:MM
        </mat-error>
      }
      @if (newDurationForm.controls.durationFrom.hasError('dateInFuture')) {
        <mat-error>
          Startzeit des Timers darf nicht in der Zukunft liegen
        </mat-error>
      }
      @if (newDurationForm.controls.durationFrom.hasError('dateFromIsGreaterThanDateTo')) {
        <mat-error>
          Startzeit darf nicht größer als Endzeit sein
        </mat-error>
      }
    </mat-form-field>
    Bis:
    <mat-form-field appearance="outline" class="durationTo">
      <input matInput formControlName="durationTo" autocomplete="off" [errorStateMatcher]="immediateMatcher"
        maxlength="5">
      @if (newDurationForm.controls.durationTo.hasError('timeFormatError')) {
        <mat-error>Zeitformat: HH:MM
        </mat-error>
      }
      @if (newDurationForm.controls.durationTo.hasError('dateInFuture')) {
        <mat-error>
          Endzeit des Timers darf nicht in der Zukunft liegen
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-select
        placeholder="type"
        [disableOptionCentering]="true"
        [required]="true"
        formControlName="activityType"
        >
        @for (type of timerService.activityTypes; track type) {
          <mat-option [value]="type">
            {{ type }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>
  <button
    [disabled]="newDurationForm.invalid"
    mat-raised-button
    color="primary"
    class="dialog-actions"
    (click)="addNewDuration(newDurationForm.controls.durationFrom.value, newDurationForm.controls.durationTo.value, newDurationForm.controls.name.value)"
    >Speichern
  </button>
  <button mat-raised-button color="warn" class="dialog-actions" mat-dialog-close="true">Abbrechen</button>
</nx-dialog>
